import { render, staticRenderFns } from "./ReferralsForm.vue?vue&type=template&id=54888226"
import script from "./ReferralsForm.vue?vue&type=script&lang=js"
export * from "./ReferralsForm.vue?vue&type=script&lang=js"
import style0 from "./ReferralsForm.vue?vue&type=style&index=0&id=54888226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports